import {getToken, getCookieAcceptance, getCookieQuestionAsked} from "./network";

const reducer = (state = {
    user: {
        login: {
            loading: false,
            error: null,
            message: null,
        },
        isAuthenticated: !!getToken(),
        resetPasswordModalOpen: false,
        cookiesAccepted: getCookieAcceptance(),
        cookieQuestionAsked: getCookieQuestionAsked()
    },
    resetPassword: {
        loading: false,
        error: null,
    },
    profile: {},
    profile_loading: false,
    profile_error: false,
    jobs: {},
    jobs_loading: false,
    jobs_error: false,
}, action) => {
    const {payload} = action

    switch (action.type) {
        case "FETCH_LOGIN":
            return {...state, user: {...state.user, login: {loading: true, error: null}, isAuthenticated: false}}
        case "RECEIVED_LOGIN":
            return {...state, user: {...state.user, login: {loading: false, error: null}, isAuthenticated: true}}
        case "LOGIN_ERROR":
            return {
                ...state,
                user: {...state.user, login: {loading: false, message: action.payload}, isAuthenticated: false}
            }
        case "LOGOUT":
            return {...state, user: {...state.user, isAuthenticated: false}}
        case "RECEIVED_RESET_PASSWORD_REQUEST":
            return {
                ...state,
                user: {
                    ...state.user,
                    login: {loading: false, message: action.payload},
                    isAuthenticated: false,
                    modalOpen: false
                }
            }
        case "RESET_PASSWORD_ERROR":
            return {
                ...state,
                user: {
                    ...state.user,
                    login: {loading: false, message: action.payload},
                    isAuthenticated: false,
                    modalOpen: true
                }
            }

        case "FETCH_CHANGE_PASSWORD":
            return {...state, resetPassword: {loading: true, error: null}}
        case "CHANGE_PASSWORD_DONE":
            return {...state, user: {...state.user, login: {loading: false, error: null, message: action.payload}}}
        case "FETCH_JOBS":
            return {...state, profile: {}, profile_loading: true, profile_error: false};
        case "RECEIVED_JOBS":
            return {...state, profile: action.payload, profile_loading: false, profile_error: false};
        case "LOAD_JOBS_ERROR":
            return {...state, profile: {}, profile_loading: false, profile_error: action.payload};
        case "SERVER_ERROR_RESET":
            return {...state, profile: {}, profile_loading: false, profile_error: false};

        case "FETCH_STATISTICS":
            return {...state, jobs: {...state.jobs}, jobs_loading: true, jobs_error: false};
        case "RECEIVED_STATISTICS":
            return {...state, jobs: {...state.jobs, ...payload}, jobs_loading: false, jobs_error: false};
        case "RECEIVED_STATISTICS_ERROR":
            return {...state, jobs: {...state.jobs, ...payload}, jobs_loading: false, jobs_error: false};
        default: {
            return state;
        }
    }
};

export default reducer;